'use strict';

var $ = require('jquery');
var Radio = require('backbone.radio');
var moment = require('moment-timezone');
var Marionette = require('backbone.marionette');

var MonthView = require('./month').default;

var KEYCODES = require('../../utilities/keycodes').default;

export default Marionette.View.extend({

  template: require('./templates/picker.hbs'),
  events: {
    'click .date-picker-back': 'onClickBack',
    'click .date-picker-next': 'onClickNext',
    'click .date-picker-day': 'onClickDay',
    'keydown .date-picker-day': 'onKeyDown',
  },

  initialize: function (options) {
    options = options || {};

    this.appointment = options.appointment;
    this.min = options.min || moment();
    this.max = options.max || null;
    this.current = options.current;
    this.length = options.length;
    this.start = this.current.clone().startOf('month');
    this.collection = options.collection;
    this.collectionEnd = options.collectionEnd;
    this.fetchTimes = options.fetchTimes;
    this.hasActiveRequests = options.hasActiveRequests;

    this.listenTo(Radio.channel('date-picker'), 'setMonth', this.setMonth);
    this.listenTo(Radio.channel('date-picker'), 'setTimezoneHtml', this.setTimezoneHtml);
    this.listenTo(Radio.channel('date-picker'), 'setCollection', this.setCollection);
  },

  serializeData: function () {
    var src_tz = window.localStorage.getItem('previous_timezone') || this.appointment.getLocation().get('timezone');
    var dest_tz = window.localStorage.getItem('timezone') || src_tz;

    return {
      month: this.start.format('MMMM YYYY'),
      timezone_abbr: moment.tz(dest_tz).zoneAbbr(),
    };
  },

  render: function () {
    this.$el.html(this.template(this.serializeData()));
    this.$el.append(this.createMonthView().render().el);

    if (!this.isBackValid()) {
      this.$('.date-picker-back').addClass('disabled');
    }

    if (!this.isNextValid()) {
      this.$('.date-picker-next').addClass('disabled');
    }

    return this;
  },

  updateCurrentAndLength: function (current, length) {
    if (!this.current.isSame(current) || this.length !== length) {
      this.current = current;
      this.length = length;

      this.render();
    }
  },

  setCollection: function (collection) {
    this.collection = collection;
  },

  updateCollectionEnd: function (end) {
    this.collectionEnd = end;
  },

  setTimezoneHtml: function (timezoneHtml) {
    $('.timezone-picker-label').html(timezoneHtml);
  },

  createMonthView: function () {
    const monthCollection = this.filterMonthCollection(this.collection.models);

    return new MonthView({
      start: this.start.clone(),
      min: this.min.clone(),
      max: this.max ? this.max.clone() : null,
      current: this.current.clone(),
      length: this.length,
      collection: monthCollection,
    });
  },

  filterMonthCollection: function (collection) {
    var self = this;
    return collection.filter(timeslot => moment(timeslot.attributes.value).clone()
      .isBetween(self.start.clone(), self.collectionEnd.clone(), 'day', '[]'),
    );
  },

  getStartOfPreviousMonth: function () {
    return this.start.clone().subtract(1, 'month').startOf('month');
  },

  getStartOfNextMonth: function () {
    return this.start.clone().add(1, 'month').startOf('month');
  },

  getStartOfSpecifiedMonth: function (date) {
    return date.clone().startOf('month');
  },

  isBackValid: function () {
    return !this.getStartOfPreviousMonth().isBefore(this.min.clone().startOf('month'), 'day');
  },

  isNextValid: function () {
    return !this.max ? true :
      this.getStartOfNextMonth().isBefore(this.max.clone().endOf('month'), 'day');
  },

  onClickBack: function (evt) {
    evt.preventDefault();
    if (this.isBackValid()) {
      this.start = this.getStartOfPreviousMonth();
      this.render();
    }
  },

  onClickNext: function (evt) {
    evt.preventDefault();
    if (this.isNextValid()) {
      var originalStart = this.start.clone();
      this.start = this.getStartOfNextMonth();
      if (this.needToLoadNextMonth()) {
        if (this.hasActiveRequests()) {
          this.start = originalStart;
          return;
        }

        this.loadNextMonth();
      } else {
        this.render();
      }
    }
  },

  loadNextMonth: function () {
    this.collectionEnd = this.collectionEnd.clone().add(this.length, 'days');
    this.collectionEnd.add(1, 'month').startOf('month');
    this.triggerMethod('setEnd', this.collectionEnd);
    this.fetchTimes(false);
  },

  needToLoadNextMonth: function () {
    return this.start.isSame(this.collectionEnd);
  },

  setMonth: function (date) {
    this.start = this.getStartOfSpecifiedMonth(date);
  },

  onClickDay: function (evt) {
    var $el = $(evt.currentTarget);
    if (!$el.hasClass('disabled')) {
      var date = moment($el.find('time').attr('datetime'));
      this.trigger('change:date', date);
    }
  },

  onKeyDown: function (evt) {
    if (evt.keyCode === KEYCODES.ENTER) {
      this.onClickDay(evt);
    }
  },

  focusFirst: function () {
    var $day = $('.date-picker-day.current').first().focus();
  },

});
